<template>
  <sla-badge-azul
    v-if="isTipoAlertaAzul"
    show-tooltip
    :tooltip-text="tooltipText.first"
    :tooltip-text2="tooltipText.second"
  />

  <sla-badge-verde
    v-else-if="isTipoAlertaVerde"
    show-tooltip
    :tooltip-text="tooltipText.first"
    :tooltip-text2="tooltipText.second"
  />

  <sla-badge-laranja
    v-else-if="isTipoAlertaLaranja"
    show-tooltip
    :tooltip-text="tooltipText.first"
    :tooltip-text2="tooltipText.second"
  />

  <sla-badge-vermelho
    v-else
    show-tooltip
    :tooltip-text="tooltipText.first"
    :tooltip-text2="tooltipText.second"
  />
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from '@vue/composition-api'
import SlaBadgeAzul from './SlaBadgeAzul.vue'
import SlaBadgeVerde from './SlaBadgeVerde.vue'
import SlaBadgeLaranja from './SlaBadgeLaranja.vue'
import SlaBadgeVermelho from './SlaBadgeVermelho.vue'
import { formatarMinutos } from '@/utils/time'

export default {
  components: {
    SlaBadgeAzul,
    SlaBadgeVerde,
    SlaBadgeLaranja,
    SlaBadgeVermelho,
  },

  props: {
    sla: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    // Contagem regressiva 100% local: os limiares (20/50/80%) são calculados uma vez a partir de
    // dataInicio/tempoSlaEmMinutos (já congelados no backend) e a cada segundo comparamos com o
    // relógio do navegador - nenhuma chamada ao backend é feita para manter isso atualizado.
    const agora = ref(Date.now())
    let intervalId = null

    onMounted(() => {
      intervalId = setInterval(() => { agora.value = Date.now() }, 1000)
    })
    onUnmounted(() => {
      clearInterval(intervalId)
    })

    const dataInicioMs = computed(() => new Date(props.sla.dataInicio).getTime())
    const tempoSlaEmMs = computed(() => props.sla.tempoSlaEmMinutos * 60 * 1000)
    const dataLimiteMs = computed(() => new Date(props.sla.dataLimite).getTime())

    const referenciaMs = computed(() => (props.sla.concluido && props.sla.dataConclusao
      ? new Date(props.sla.dataConclusao).getTime()
      : agora.value))

    const progresso = computed(() => (referenciaMs.value - dataInicioMs.value) / tempoSlaEmMs.value)

    const isTipoAlertaAzul = computed(() => progresso.value <= 0.2)
    const isTipoAlertaVerde = computed(() => progresso.value > 0.2 && progresso.value <= 0.5)
    const isTipoAlertaLaranja = computed(() => progresso.value > 0.5 && progresso.value <= 0.8)

    const tooltipText = computed(() => {
      if (props.sla.concluido) {
        return {
          first: `SLA de ${props.sla.tipoSlaNome}: concluído`,
          second: `Tempo: ${formatarMinutos(props.sla.tempoRealizadoMinutos)}`,
        }
      }

      const diferencaMinutos = Math.round((dataLimiteMs.value - agora.value) / 60000)

      const tempo = diferencaMinutos >= 0
        ? `Restam ${formatarMinutos(diferencaMinutos)}`
        : `Atrasado há ${formatarMinutos(Math.abs(diferencaMinutos))}`

      return { first: `SLA de ${props.sla.tipoSlaNome}`, second: tempo }
    })

    return {
      isTipoAlertaAzul,
      isTipoAlertaVerde,
      isTipoAlertaLaranja,
      tooltipText,
    }
  },
}
</script>
